import React from 'react'

export type EditIconProps = {
  size?: number
  color?: string
}

export const EditIcon = ({
  size = 14,
  color = 'currentColor',
}: EditIconProps) => (
  <svg
    fill='none'
    height={size}
    viewBox='0 0 10 10'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.52558 1.44884H1.39457C1.15732 1.44884 0.92978 1.54309 0.762014 1.71085C0.594249 1.87862 0.5 2.10616 0.5 2.34341V8.60543C0.5 8.84268 0.594249 9.07022 0.762014 9.23799C0.92978 9.40575 1.15732 9.5 1.39457 9.5H7.65659C7.89384 9.5 8.12138 9.40575 8.28915 9.23799C8.45691 9.07022 8.55116 8.84268 8.55116 8.60543V5.47442M7.88023 0.777908C8.05817 0.599967 8.29951 0.5 8.55116 0.5C8.80281 0.5 9.04415 0.599967 9.22209 0.777908C9.40003 0.95585 9.5 1.19719 9.5 1.44884C9.5 1.70049 9.40003 1.94183 9.22209 2.11977L4.97287 6.36899L3.18372 6.81628L3.63101 5.02713L7.88023 0.777908Z'
      stroke={color}
      strokeWidth='1'
    />
  </svg>
)
